const initialState = {};
const state = {
  ...initialState,
  categories: [],
  results: [],
  pagination: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 0,
    count: 10,
  },
  filter: {
    category: null,
    searchField: null,
    isAtive: true,
  },
};

export default state;
